import React, { useState } from "react";
import {
  Box,
  Button,
  Drawer,
  FormControl,
  Grid,
  TextField,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Loader from "../component/loading-screen/Loader";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import { postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";

const AddMerchant = ({ refresh }) => {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState(false);
  const [userId, setUserId] = useState("");

  const [formData, setFormData] = useState({
    merchant_id: "",
    merchant_secret: "",
  });

  // Open Drawer
  const handleOpen = () => {
    setOpen(true);
  };

  // Close Drawer
  const handleClose = () => {
    setFormData({
      merchant_id: "",
      merchant_secret: "",
    });
    setUserId("");
    setOpen(false);
  };

  // Handle Input Changes
  const handleInputChange = (e) => {
    const { id, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  // Handle Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      user_id: userId,
      merchant_id: formData.merchant_id,
      merchant_secret: formData.merchant_secret,
    };

    postJsonData(
      ApiEndpoints.ADD_MERCHANT,
      data,
      setRequest,
      (res) => {
        handleClose();
        okSuccessToast(res?.data?.message || res?.message);

        if (refresh) {
          refresh();
        }
      },
      (err) => {
        apiErrorToast(err);
      },
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "end",
      }}
    >
      <Button
        variant="outlined"
        onClick={handleOpen}
        startIcon={<AddCircleOutlineIcon />}
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "8px",
          fontSize: "12px",
          color: "#ffffff",
          fontWeight: "700",
          borderRadius: "8px",
          transition: "all 0.3s ease",
          justifyContent: "center",
          background: "#00693E",
          "&:hover": {
            backgroundColor: "#122480",
          },
        }}
        aria-label="Add Merchant"
      >
        Merchant
      </Button>

      <Drawer open={open} onClose={handleClose} anchor="right">
        <Box sx={{ width: 400, p: 2 }}>
          <Loader loading={request} />

          <ModalHeader title="Add Merchant" handleClose={handleClose} />

          <Box
            component="form"
            id="addMerchantForm"
            autoComplete="off"
            onSubmit={handleSubmit}
            sx={{
              "& .MuiTextField-root": { m: 1 },
            }}
          >
            <Grid container>
              {/* USER ID */}
              <Grid item xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="User ID"
                    id="user_id"
                    type="number"
                    size="small"
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                    required
                    placeholder="Enter User ID"
                  />
                </FormControl>
              </Grid>

              {/* MERCHANT ID */}
              <Grid item xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Merchant Id"
                    id="merchant_id"
                    size="small"
                    value={formData.merchant_id}
                    onChange={handleInputChange}
                    required
                  />
                </FormControl>
              </Grid>

              {/* MERCHANT SECRET */}
              <Grid item xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Merchant Secret"
                    id="merchant_secret"
                    size="small"
                    value={formData.merchant_secret}
                    onChange={handleInputChange}
                    required
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Box sx={{ mt: 2 }}>
              <ModalFooter form="addMerchantForm" request={request} />
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default AddMerchant;
